import clsx from 'clsx';
import { PropsWithChildren, ReactNode } from 'react';
import { Helmet } from 'react-helmet';

import { Content, pageLayoutClasses, Root } from './PageLayout.styled';

export interface PageLayoutProps {
  className?: string;
  fullHeight?: boolean;
  renderHeader?: ReactNode;
  title?: string;
  disablePadding?: boolean;
}

export const PageLayout = ({
  className,
  children,
  fullHeight,
  disablePadding,
  renderHeader,
  title,
}: PropsWithChildren<PageLayoutProps>) => {
  const content = fullHeight ? (
    <Content className={clsx(pageLayoutClasses.content, pageLayoutClasses.fullHeight)} disablePadding={disablePadding}>
      {children}
    </Content>
  ) : (
    children
  );
  return (
    <>
      {title && (
        <Helmet>
          <title>{title}</title>
        </Helmet>
      )}
      <Root
        className={clsx(className, pageLayoutClasses.root, fullHeight ? pageLayoutClasses.fullHeight : undefined)}
        fullHeight={fullHeight}
        disablePadding={disablePadding}
      >
        {renderHeader}
        {content}
      </Root>
    </>
  );
};
